module.exports = __webpack_public_path__ + "static/media/analytics.62c3364d.svg";